import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AdvisorsUIHelpers";

const AdvisorsUIContext = createContext();

export function useAdvisorsUIContext() {
  return useContext(AdvisorsUIContext);
}

export const AdvisorsUIConsumer = AdvisorsUIContext.Consumer;

export function AdvisorsUIProvider({ advisorsUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewStudentPage: advisorsUIEvents.openNewStudentPage
  };

  return (
    <AdvisorsUIContext.Provider value={value}>
      {children}
    </AdvisorsUIContext.Provider>
  );
}